import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import {connect} from 'react-redux'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IntlMessages from 'util/IntlMessages';
import { loggedOut, loggedIn } from 'actions/Api'

class UserInfo extends React.Component {

    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({open: true, anchorEl: event.currentTarget});
    };

    handleRequestClose = () => {
        this.setState({open: false});
    };

    handleRequestLogout = () => {
        // TODO: FB.logout();
        this.props.dispatch(loggedOut());
        this.setState({open: false});
    };

    render() {
        return (
            <div className="user-profile d-flex flex-row align-items-center">
                {
                    // Avatar with image url
                }
                <Avatar
                    alt={this.props.contactData && (this.props.contactData.firstName + this.props.contactData.lastName)}
                    className="user-avatar bg-secondary"
                >
                    {this.props.contactData && this.props.contactData.firstName && this.props.contactData.firstName.substr(0,1).toUpperCase()}{this.props.contactData && this.props.contactData.lastName && this.props.contactData.lastName.substr(0,1).toUpperCase()}
                </Avatar>
                <div className="user-detail">
                    <h4 className="user-name" onClick={this.handleClick}>{this.props.contactData && this.props.contactData.firstName} {this.props.contactData && this.props.contactData.lastName} <i
                        className="zmdi zmdi-caret-down zmdi-hc-fw align-middle"/>
                    </h4>
                </div>
                <Menu className="user-info"
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={this.state.open}
                      onClose={this.handleRequestClose}
                      PaperProps={{
                          style: {
                              width: 120,
                              paddingTop: 0,
                              paddingBottom: 0
                          }
                      }}
                >
                {/*
                    <MenuItem onClick={this.handleRequestClose}>
                        <i className="zmdi zmdi-account zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.profile"/>
                    </MenuItem>
                    <MenuItem onClick={this.handleRequestClose}>
                        <i className="zmdi zmdi-settings zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.setting"/>
                    </MenuItem>
                */}
                    <MenuItem onClick={this.handleRequestLogout}>
                        <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2"/>
                        <IntlMessages id="popup.logout"/>
                    </MenuItem>
                </Menu>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        locale: state.settings.locale,
        contactData: state.profile && state.profile.contactData
    }
};

({settings}) => {
    const {locale} = settings;
    return {locale}
};
export default connect(mapStateToProps)(UserInfo);


